import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const DailyPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      const hours = now.getHours();
      const today = now.toDateString();

      const lastDismissed = localStorage.getItem("popupDismissed");
      if (hours >= 18 && lastDismissed !== today) {
        setOpen(true); // Open the dialog
      }
    };

    const interval = setInterval(checkTime, 60000); // Check every minute (60000ms)

    // Initial check in case the component mounts after 6 PM
    checkTime();

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("popupDismissed", new Date().toDateString()); // Store dismissal date
  };

  return (
    <Dialog
      open={open}
      onClose={() => { }} // Prevent closing on backdrop click
      disableEscapeKeyDown // Prevent closing on Escape key
      slotProps={{
        backdrop: {
          onClick: (e) => e.stopPropagation(), // Prevent backdrop click from closing
        },
      }}
      aria-labelledby="daily-popup-title"
      aria-describedby="daily-popup-description"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          padding: 2,
          maxWidth: 500,
        },
      }}
    >
      <DialogTitle id="daily-popup-title">
        <Typography variant="h6" component="span" color="primary">
          Patient Arrival Status – Reminder
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="daily-popup-description" color="text.primary">
          Kindly update the records to indicate whether each patient has arrived for their scheduled appointment.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
          sx={{ minWidth: 80 }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DailyPopup;